import { render } from "./App.vue?vue&type=template&id=c77c69a2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c77c69a2&lang=css"

import exportComponent from "F:\\Github\\SIAVCH\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__